import Vue from 'vue'
import VueI18n from 'vue-i18n'
import elementEnLocale from 'element-ui/lib/locale/lang/en' //引入el自带得国际化语言包,防止内部插件出现乱码
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'//引入el自带得国际化语言包,防止内部插件出现乱码

// 导入项目中用到的中文/英文语言包
import enLogin from './lang/En/login-en' 
import zhLogin from './lang/Zh/login-zh'
import ehsmartCity from './lang/En/smartCity-en'
import zhsmartCity from './lang/Zh/smartCity-zh'
import zhreport from './lang/Zh/report-zh'
import enreport from './lang/En/report-en'
import ensmartElectricity from './lang/En/smartElectricity-en'
import zhsmartElectricity from './lang/Zh/smartElectricity-zh'

import zhuseGas from './lang/Zh/useGas-zh'
import enuseGas from './lang/En/useGas-en'

import zhstore from './lang/Zh/store-zh'
import enstore from './lang/En/store-en'





Vue.use(VueI18n)
const messages = {
  en: {
    ...enstore,
    ...enuseGas,
    ...ensmartElectricity,
    ...enreport,
    ...ehsmartCity,
    ...enLogin,
    ...elementEnLocale
  },
  zh: {
    ...zhstore,
    ...zhuseGas,
    ...zhsmartElectricity,
    ...zhreport,
    ...zhsmartCity,
    ...zhLogin,
    ...elementZhLocale,
  },
 
}
 
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'zh', // 设置语种
  messages, // 设置全局当地语言包,
  fallbackLocale: 'zh',
  numberFormats:{ //设置 数字本地化
    'en': {
      currency: { //添加 $
        style: 'currency', currency: 'USD'
      }
    },
    'zh': {
      currency: { //添加 ￥
        style: 'currency', currency: 'JPY', currencyDisplay: 'symbol'
      }
    }
  },
    dateTimeFormats:{//设置 日期时间本地化
    'en': {
      short: { 
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
        year: 'numeric', month: 'short', day: 'numeric',
        weekday: 'short', hour: 'numeric', minute: 'numeric'
      }
    },
    'zh': {
      short: {
        year: 'numeric', month: 'short', day: 'numeric'
      },
      long: {
            year: 'numeric', month: 'short', day: 'numeric',
            weekday: 'short', hour: 'numeric', minute: 'numeric'  
      }
    }
  }
})


 
export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js